module.exports = __webpack_public_path__ + "assets/img/a4.3938c99c.jpg";